import React from 'react';
import { useFormContext } from 'react-hook-form';
import cx from 'classnames';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import { getAutofillString } from '../utils';
import FieldWrapper from './FieldWrapper';

import { radio, radioRow } from '../styles.module.css';

export const RadioRaw = ({
  className,
  inputProps,
  options,
  name,
  id,
  checked,
}) => {
  return (
    <div className={cx(className, GLOBAL_FORM_STYLES_CLASS)}>
      {options.map(({ label: radioLabel, value }) => {
        const inputId = `${id}-${name}-${value}`;

        return (
          <div className={radio} key={value}>
            <input
              key={`${inputId}-${checked}`}
              id={inputId}
              type="radio"
              defaultChecked={checked === value}
              name={name}
              value={value}
              {...inputProps}
            />
            <label htmlFor={inputId}>{radioLabel}</label>
          </div>
        );
      })}
    </div>
  );
};

const Radio = (props) => {
  const { register } = useFormContext();
  const {
    id,
    required = false,
    validation,
    options,
    optionLabels,
    title,
    disabled,
    className,
    classNameRaw,
  } = props;
  const inputProps = {
    className,
    disabled,
    autoComplete: getAutofillString(id),
    ref: register({
      required: required && `${title} required`,
      ...validation,
    }),
  };
  const radioOptions = options.map((o, i) => ({
    value: o,
    label: optionLabels?.[i] || o,
  }));

  return (
    <FieldWrapper {...props}>
      <RadioRaw
        options={radioOptions}
        inputProps={inputProps}
        id={id}
        name={id}
        className={cx(radioRow, classNameRaw)}
      />
    </FieldWrapper>
  );
};

export default Radio;
